<template>
  <transition @enter="enter" @leave="leave" appear :css="false">
    <div v-if="!$store.state.loaded" class="loader" :class="{ 'loader--in-app' : $inApp }">
      <p class="loader__text">
        {{ $translate('loader') }}
        <span class="text__dot">.</span>
        <span class="text__dot">.</span>
        <span class="text__dot">.</span>
      </p>
    </div>
  </transition>
</template>

<script>
import { gsap } from 'gsap';

export default {
  name: 'Loader',

  methods: {
    enter(el, done) {
      const text = el.querySelector('.loader__text');

      gsap.from(text, {
        autoAlpha: 0,
        y: 35,
        duration: 0.5,
        delay: 0.3,
        ease: 'power3.out',
        onComplete: done,
      });
    },
    leave(el, done) {
      const text = el.querySelector('.loader__text');

      gsap.to(text, {
        y: -35,
        autoAlpha: 0,
        duration: 0.5,
        ease: 'power3.in',
        onComplete: () => {
          done();
          this.$store.commit('SET_MODE', 'intro');
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes dot-flap {
  0% {
    transform: translateY(0) scaleY(1);
    transform-origin: 50% 0%;
  }
  30% {
    transform: translateY(-5px) scaleY(1.2);
    transform-origin: 50% 100%;
  }
  70% {
    transform: translateY(0) scaleY(1);
  }
  100% {
    transform: translateY(0) scaleY(1);
  }
}

.loader {
  @include full(true);

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  z-index: 10;

  &,
  &__bg {
    top: 0px;
    left: 0px;
  }

  &__text {
    position: relative;

    color: $color-yellow;
    font-weight: 800;
    @extend %font-medium;
    text-transform: uppercase;
  }

  .text__dot {
    display: inline-block;

    &:nth-child(1) {
      animation: dot-flap 1.75s $flap 0s infinite normal;
    }
    &:nth-child(2) {
      animation: dot-flap 1.75s $flap 0.25s infinite normal;
    }
    &:nth-child(3) {
      animation: dot-flap 1.75s $flap 0.5s infinite normal;
    }
  }
}
</style>
